const VERIFIER_KEY = "pkce_code_verifier";

const generateVerifier = (length: number = 43): string => {
  const charset =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
  return Array.from({ length }, () =>
    charset.charAt(Math.floor(Math.random() * charset.length))
  ).join("");
};

export const getVerifier = (): string => {
  let verifier = sessionStorage.getItem(VERIFIER_KEY);
  if (!verifier) {
    verifier = generateVerifier();
    sessionStorage.setItem(VERIFIER_KEY, verifier);
  }
  return verifier;
};

// PKCE helpers
export const sha256 = async (plain: string) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return window.crypto.subtle.digest("SHA-256", data);
};

export const base64urlencode = (a: ArrayBuffer) => {
  const bytes = new Uint8Array(a);
  let binary = "";
  bytes.forEach((b) => (binary += String.fromCharCode(b)));

  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

export const pkceChallengeFromVerifier = async (v: string) => {
  const hashed = await sha256(v);
  return base64urlencode(hashed);
};
